export default __webpack_public_path__ + "static/media/placement_force.995003f0.pdf";